import { I18n } from 'react-redux-i18n';
import React from 'react';
import { ChipDropdown } from '../../components/V2ContextBar';
import type { MarketSelectionContext } from '../../components/posFilterTypes';

interface SurveyDateControlProps {
  context: MarketSelectionContext;
  years: string[];
  // Effective survey year for the context ('all' = current view).
  value: string;
  disabled: boolean;
  onChange: (year: string) => void;
}

// ON premium: dates are the union of the selected markets' dates (disabled
// without a market) and there is no current view. ON full: always the current
// view (locked). OFF: a single survey year.
export const SurveyDateControl: React.FC<SurveyDateControlProps> = ({
  context,
  years,
  value,
  disabled,
  onChange
}) => {
  const isFull = context === 'on_full';
  const isPremium = context === 'on_premium';
  return (
    <>
      <ChipDropdown
        options={years.map((year) => ({ value: year, label: year }))}
        value={isFull || value === 'all' ? null : value}
        onChange={(next) => onChange(String(next ?? 'all'))}
        showAllOption={isFull}
        disabled={isFull || disabled || (isPremium && years.length === 0)}
        placeholder={I18n.t(
          isFull
            ? 'v2GlobalView.currentView'
            : 'v2GlobalView.contextBar.marketPlaceholder'
        )}
        allLabel={I18n.t('v2GlobalView.currentView')}
        variant="dark"
        neutral
      />
    </>
  );
};
